import api from './apiConfig';
import { EventEmitter } from 'events';

// Event types
export const CODEX_TYPE_EVENTS = {
  UPDATED: 'codex_types_updated'
};

// Set up event emitter for real-time updates
const eventEmitter = new EventEmitter();

// Emit events
const emitEvent = (eventName, data) => {
  eventEmitter.emit(eventName, data);
};

// Subscribe to codex type events
export const subscribeToCodexTypeEvents = (callback) => {
  eventEmitter.on(CODEX_TYPE_EVENTS.UPDATED, callback);
  
  // Return unsubscribe function
  return () => {
    eventEmitter.off(CODEX_TYPE_EVENTS.UPDATED, callback);
  };
};

const codexTypeService = {
  getAll: async () => {
    try {
      const response = await api.get('/codex-types');
      return response.data;
    } catch (error) {
      console.error('Error fetching codex types:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/codex-types/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching codex type ${id}:`, error);
      throw error;
    }
  },

  create: async (codexTypeData) => {
    try {
      const response = await api.post('/codex-types', codexTypeData);
      return response.data;
    } catch (error) {
      console.error('Error creating codex type:', error);
      throw error;
    }
  },

  update: async (id, codexTypeData) => {
    try {
      const response = await api.put(`/codex-types/${id}`, codexTypeData);
      return response.data;
    } catch (error) {
      console.error(`Error updating codex type ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/codex-types/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting codex type ${id}:`, error);
      throw error;
    }
  }
};

export default codexTypeService; 